export const SAVED_VIEW_OPEN_SOURCES = {
  index: 'index',
  direct: 'direct',
  created: 'created',
  sidebar: 'sidebar',
} as const

export type SavedViewOpenSource = (typeof SAVED_VIEW_OPEN_SOURCES)[keyof typeof SAVED_VIEW_OPEN_SOURCES]

export type SavedViewOpenLocationState = {savedViewOpenSource: SavedViewOpenSource}
